<div
    class="dialog-header"     cdkDrag 
    cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle >
    <h2 mat-dialog-title>Project Timer</h2>
    <div>
    <button mat-icon-button><mat-icon title="Open timer help." (click)="openHelp()">help</mat-icon></button>
    </div>
    <mat-icon>drag_indicator</mat-icon>
</div>
<mat-dialog-content 
    class="dialog-container"
>
    <h4 class="margin-top-none">{{ data.day | date: 'EEE, M/d' }}: "{{ data.project.title }}"</h4>
    <div class="timer-display">{{ (1000 * elapsedTime) | time }} ({{displayHours}} hours)</div>
    <div class="timer-subtext">
        &rarr;
        @if(data.startTime) { Resumed } @else { Started at }
        {{ startDate | date: 'h:mm a, MMM d' }}@if(!data.startTime){.}
        @if (data.startTime) { from {{ startHoursDisplay }} hours }
    </div>
    <mat-form-field appearance="fill" class="notes-field">
        <mat-label>Notes</mat-label>
        <textarea matInput [formControl]="notesControl"></textarea>
    </mat-form-field>
    <div class="last-saved">
        @if (lastSaved) { Autosaved: {{lastSaved | date: 'hh:mm:ss a'}}. }
    </div>

    <mat-dialog-actions align="end">
        <button mat-flat-button color="primary" (click)="accept()"><mat-icon>pause</mat-icon> Save and Close</button>
        <button mat-button (click)="resetTimer()"><mat-icon>skip_previous</mat-icon> Reset</button>
        <button mat-button (click)="cancel()"><mat-icon>delete</mat-icon>Cancel</button>
    </mat-dialog-actions>
</mat-dialog-content>